import React from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import Table from '../../../components/Table/Table';
import CustomStarFilterForm from '../../../components/Table/TableFilterForms/CustomStarFilterForm';
import CustomerFeedBackLogs from '../../../components/Table/TableMobileResponsiveCells/CustomerFeedBackLogs';

const FeedbackAnalysisTable = () => {
  const { driverId } = useParams();

  return (
    <Container>
      <Table
        mobileOnlyView
        filterBoxBottomBorder
        border
        tableFilterBoxFeatures={{
          rightAttr: [
            {
              type: 'custom-filter',
              comp: <CustomStarFilterForm />,
            },
          ],
          leftAttr: [
            {
              type: 'regular',
              comp: <Label>Customer Feedback Log</Label>,
            },
          ],
        }}
        tableHeader={{}}
        tableDataSourceUrl={`api/v1/dispatchers/${driverId}/feedbacks`}
        size={10}
        mobileCellComp={<CustomerFeedBackLogs />}
      />
    </Container>
  );
};

export default FeedbackAnalysisTable;

const Container = styled.div`
  display: flex;
  gap: 28px;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;
